<template>
    <div>
        <el-form :model="landSearchFilter" ref="projectForm" :rules="rules" label-position="left" class="employer-ruleForm">
        <el-row>
            <el-col :span="12">
                <el-form-item label="投资日期" prop="startDate" :label-width="labelWidth">
                    <el-date-picker size="large" v-model="landSearchFilter.startDate" type="date"
                        placeholder="选择开始时间"></el-date-picker> -
                    <el-date-picker v-model="landSearchFilter.endDate" type="date"
                        placeholder="选择结束时间"></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="投资地点" prop="area" :label-width="labelWidth">
                    <el-select class="seletc-size-input" v-model="landSearchFilter.province" placeholder="请选择">
                        <el-option v-for="(item, index) in provinceList" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select class="seletc-size-input" v-model="landSearchFilter.city" placeholder="请选择">
                        <el-option v-for="(item, index) in cityList" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select class="seletc-size-input" v-model="landSearchFilter.county" placeholder="请选择">
                        <el-option v-for="(item, index) in countyList" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="概念" prop="notionCode1" :label-width="labelWidth">
                    <el-select class="seletc-size-input" v-model="landSearchFilter.notionCode1" placeholder="请选择">
                        <el-option v-for="(item, index) in notionList1" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select class="seletc-size-input" v-model="landSearchFilter.notionCode2" placeholder="请选择">
                        <el-option v-for="(item, index) in notionList2" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select class="seletc-size-input" v-model="landSearchFilter.notionCode3" placeholder="请选择">
                        <el-option v-for="(item, index) in notionList3" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="投资企业区域" prop="bigLandUseList" :label-width="labelWidth">
                    <el-select  v-model="landSearchFilter.bigLandUse" placeholder="请选择">
                        <el-option v-for="(item, index) in bigLandUseList" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select v-model="landSearchFilter.smallLandUse" placeholder="请选择">
                        <el-option v-for="(item, index) in smallLandUseList" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="行业" prop="notionCode1" :label-width="labelWidth">
                    <el-select class="seletc-size-input" v-model="landSearchFilter.notionCode1" placeholder="请选择">
                        <el-option v-for="(item, index) in notionList1" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select class="seletc-size-input" v-model="landSearchFilter.notionCode2" placeholder="请选择">
                        <el-option v-for="(item, index) in notionList2" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select class="seletc-size-input" v-model="landSearchFilter.notionCode3" placeholder="请选择">
                        <el-option v-for="(item, index) in notionList3" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="产业分类" prop="bigLandUseList" :label-width="labelWidth">
                    <el-select class="seletc-size-input" v-model="landSearchFilter.notionCode1" placeholder="请选择">
                        <el-option v-for="(item, index) in notionList1" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select class="seletc-size-input" v-model="landSearchFilter.notionCode2" placeholder="请选择">
                        <el-option v-for="(item, index) in notionList2" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                    <el-select class="seletc-size-input" v-model="landSearchFilter.notionCode3" placeholder="请选择">
                        <el-option v-for="(item, index) in notionList3" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="投资模式" prop="minSize" :label-width="labelWidth">
                    <el-select v-model="landSearchFilter.investMode" placeholder="请选择">
                        <el-option v-for="(item, index) in investModeList" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="融资方式" prop="minPrice" :label-width="labelWidth">
                    <el-select  v-model="landSearchFilter.financeMode" placeholder="请选择">
                        <el-option v-for="(item, index) in financeModeList" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="公司名称" prop="floorAreaRatio" :label-width="labelWidth">
                    <el-input class="text-input" v-model="landSearchFilter.companyName" placeholder=""></el-input>
                </el-form-item> 
            </el-col>
            <el-col :span="12">
                <el-form-item label="项目名称" prop="useYears" :label-width="labelWidth">
                    <el-input class="text-input" v-model="landSearchFilter.useYears" placeholder=""></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="金额 >= " prop="minPrice" :label-width="labelWidth">
                    <el-input class="text-input" v-model="landSearchFilter.minPrice" placeholder=""></el-input>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
    <div class="btn oh mr-8 mb-2">
        <div class="fr">
             <el-button icon="el-icon-search" type="primary" @click="search">查询</el-button>
            <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </div>
    </div>
    </div>
</template>
<script>
export default {
    name: 'landFilterCom',
    data() {
        return {
            labelWidth: '120px',
            rules: {},
            landSearchFilter: {
                startDate: '',
                endDate: '',
                area: '',
                bigLandUse: '',
                minSize: '',
                minPrice: '',
                notionCode1: '',
                notionCode2: '',
                maxPrice: '',
                maxSize: '',
                minFloorAreaRatio: '',
                maxFloorAreaRatio: '',
                useYears: '',
                landLevel: '',
                investMode: '',
                financeMode: '',
                companyName: '',
                projectName: '',
                projectLocation: '',
                province: '',
                city: '',
                county: '',
                projectType: '',
                projectLevel: '',
                
            },
            investModeList: [
                { value: '1', label: '自有' },
                { value: '2', label: '合作' },
            ],
            financeModeList: [
                { value: '1', label: '融资' },
                { value: '2', label: '自筹' },
            ],
            provinceList: [
                { value: '1', label: '北京' },
                { value: '2', label: '天津' },
                { value: '3', label: '河北' },
                { value: '4', label: '山西' },
                { value: '5', label: '内蒙古' },
                { value: '6', label: '辽宁' },
                { value: '7', label: '吉林' },
            ],
            cityList: [
                { value: '1', label: '保定' },
                { value: '2', label: '北京' },
                { value: '3', label: '石家庄' },
            ],
            countyList: [
                { value: '1', label: '东城区' },
                { value: '2', label: '西城区' },
                { value: '3', label: '海淀区' },
                { value: '4', label: '朝阳区' },
                { value: '5', label: '丰台区' },
                { value: '6', label: '石景山区' },
            ],
            bigLandUseList: [
                { value: '1', label: '住宅' },
                { value: '2', label: '商住' },
                { value: '3', label: '商住' },
                { value: '4', label: '商住' },
                { value: '5', label: '商住' },
                { value: '6', label: '商住' },
            ],
            smallLandUseList: [
                { value: '1', label: '住宅' },
                { value: '2', label: '商住' },
                { value: '3', label: '商住' },
                { value: '4', label: '商住' },
                { value: '5', label: '商住' },
                { value: '6', label: '商住' },
            ],
            notionList1: [{ value: '1', label: '机器人' }],
            notionList2:[{ value: '1', label: '制造业' }],
            notionList3: [{ value: '1', label: '机器人制造' },]
        }
    },
    created() { 
    },
    mounted() { 
    },
    methods: {
        search() {
            this.$emit('search', this.landSearchFilter)
        },
        reset() {
            this.landSearchFilter = {
                province: '',
                city: '',
                county: '',
                parentProvince: '',
                parentCity: '',
                parentCounty: '',
                notionCode1: '',
                notionCode2: '',
            }
        }
    }
}
</script>
<style scoped lang="scss">
::v-deep {
    .text-input{
        width: 70%
    }
    .el-input__inner{
        font-size: 14px;
        // line-height: 80px;
        height: 38px;
    }
    .el-form-item__label{
        font-weight: bold;
        font-size: 16px;
        color: #333;
    }
    .num-size-input{
        width: 180px;
    }
    .seletc-size-input{
        width: 140px;
    }
}
</style>